import { gql } from "__generated__/gql";
import { removeDeletedRecords } from "utils/apollo/cacheHelpers";
import { useBrandMutation } from "utils/apollo/hooks/brand";
import { assertPresence } from "utils/assertions";
import DeleteConfirmModalButton from "components/Shared/ConfirmModal/DeleteConfirmModalButton";

const mutation = gql(/* GraphQL */ `
  mutation ProductLinePanelDeleteManufacturingFacility($facilityId: UUID!) {
    deleteManufacturingFacility(input: { id: $facilityId }) {
      manufacturingFacility {
        id
        name
      }
    }
  }
`);

type Props = {
  facilityId: UUID;
};

export default function DeleteManufacturingFacilityButton({
  facilityId,
}: Props) {
  const mutationTuple = useBrandMutation(mutation, {
    variables: { facilityId },
    update: (cache, result) => {
      const deletedFacility =
        result.data?.deleteManufacturingFacility?.manufacturingFacility;
      assertPresence(deletedFacility);
      removeDeletedRecords({
        cache,
        baseFieldName: "manufacturingFacilities",
        deletedRecords: [deletedFacility],
      });
    },
  });

  return (
    <DeleteConfirmModalButton
      label="Delete Manufacturing Facility"
      mutation={mutationTuple}
    />
  );
}
